import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'views.Intro.Components.ReportBox.title',
    defaultMessage: 'Multimedialny raport {year}'
  },
  annualSipleReportTitle: {
    id: 'views.Intro.Components.ReportBox.annualSipleReportTitle',
    defaultMessage: 'Raport roczny {year}'
  },
  titleQuarter: {
    id: 'views.Intro.Components.ReportBox.titleQuarter',
    defaultMessage: 'Multimedialny raport {quarter} kwartał {year}'
  },
  description: {
    id: 'views.Intro.Components.ReportBox.description',
    defaultMessage:
      'Poznaj najnowsze wyniki finansowe Grupy Kapitałowej TenderHut.'
  },
  button: {
    id: 'views.Intro.Components.ReportBox.button',
    defaultMessage: 'Zobacz raport'
  },
  issueOfShares: {
    id: 'views.issueOfShares.mainPageDescription',
    defaultMessage:
      'Zapoznaj się z informacjami o najnowszej emisji akcji TenderHut S.A.'
  },
  issueOfSharesButton: {
    id: 'views.issueOfShares.mainPageButton',
    defaultMessage: 'Zainwestuj teraz'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/Components/ReportBox/ReportBox.intl.js